import DataBaseAdminRoutes from './DataBaseAdminRoutes';

export default DataBaseAdminRoutes;
